export const getInitials = (fullName: string) => {
    if (!fullName) return '';

    return fullName
        .split(' ')                 // Pisahkan nama berdasarkan spasi
        .filter(name => name.length > 0) // Hindari spasi berlebih yang menghasilkan string kosong
        .map(name => name[0])       // Ambil huruf pertama dari setiap nama
        .slice(0, 2)                // Ambil maksimal 2 huruf pertama
        .join('')                   // Gabungkan huruf-huruf menjadi satu string
        .toUpperCase();             // Ubah menjadi huruf kapital
}
